import { z } from "zod";

import { prayerSchema } from "../../../../../lib/types/schema/prayer/prayerSchema";

const prayerSchemaWithDateAvailable = prayerSchema.extend({
  date_available: z.iso.datetime().nullable(),
});

export const communityAssignmentSchema = z.object({
  content: prayerSchemaWithDateAvailable,
  content_type: z.literal("prayer"),
  due_at: z.iso.datetime(),
  id: z.number(),
  percentage_users_completed: z.number().nullable(),
  status: z.enum(["past", "upcoming"]),
});

export type CommunityAssignment = z.TypeOf<typeof communityAssignmentSchema>;
